// Tutorial hero — "From spreadsheet to system", three plain-English stat
// chips, and jump buttons to each section.

import React from 'react';
import useReducedMotion from './useReducedMotion';

const CTAS = [
  { id: 'tut-map', label: 'Your workbook, mapped' },
  { id: 'tut-numbers', label: 'How the numbers work' },
  { id: 'tut-try', label: 'Try it' },
  { id: 'tut-where', label: 'Where things live' },
];

export default function HeroSection() {
  const reduced = useReducedMotion();
  const jump = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  };
  return (
    <header className="tut-hero">
      <div className="tut-hero-inner">
        <div className="tut-hero-kicker">Budget module · a guided tour</div>
        <h1>
          From spreadsheet
          <br />
          to system.
        </h1>
        <p className="tut-hero-sub">
          Everything <strong>Tax Budget FY2026.xlsx</strong> does today — live, auditable, and
          never waiting on a quarter-end reconciliation.
        </p>
        <div className="tut-hero-stats">
          <span className="tut-stat">
            <strong className="num">120</strong> budget lines
          </span>
          <span className="tut-stat">
            <strong>every SAP line</strong> auto-categorized
          </span>
          <span className="tut-stat">
            updates <strong>the moment SAP data lands</strong>
          </span>
        </div>
        <div className="tut-hero-ctas">
          {CTAS.map((c, i) => (
            <button
              key={c.id}
              type="button"
              className={`tut-btn ${i === 0 ? 'primary' : 'ghost-light'}`}
              onClick={() => jump(c.id)}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
